import { t } from "i18next";
import { useEffect, useState } from "react";
import { TrainingSessionExercise, TrainingSessionPhase, TrainingSession, emptyTrainingSession } from "../../../../interfaces/training-session";
import { useParams } from "react-router-dom";
import { Accordion, Alert, Col, Nav, Row, Tab } from "react-bootstrap";
import { EntityVideos } from "../../../general/entity-videos";
import { getAthleteTrainingSessionView } from "../../../../services/training-session";
import { LoadingSpinner } from "../../../general/loading-spinner";
import moment from 'moment';

export function AthleteTrainingSessionView() {
    const params: any = useParams();

    const [trainingSession, setTrainingSession] = useState<TrainingSession>(emptyTrainingSession);
    const [loaded, setLoaded] = useState(false);
    
    useEffect(() => {
        getAthleteTrainingSessionView(params.id)
            .then((response: any) => {
                setTrainingSession(response.data);
                setLoaded(true);
            });
    }, []);

    const handleVideosChange = () => {

    }

    return (
        <div className="training-session-phases-container">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded && trainingSession.phases != undefined &&
                <div className="phases-content">
                    <h1>{ trainingSession.name }</h1>
                    { trainingSession.phases.length > 0 &&
                        <Tab.Container id="phases-tabs" defaultActiveKey={ 'phase-' + trainingSession.phases[0].id}>
                            <Row>
                                <Col lg={3}>
                                    <h4>{ moment(trainingSession.date_time).format('D MMMM, hh:mm') }</h4>
                                    <Nav variant="pills" className="flex-column">
                                        {
                                            trainingSession.phases.map((p: TrainingSessionPhase) => {
                                                const numExercises = p.exercises.length;
                                                return <Nav.Item  key={ 'phase-nav-' + p.id }>
                                                        <Nav.Link eventKey={ 'phase-' + p.id }>
                                                            { p.name }
                                                            <span className="exercises">
                                                                { (numExercises == 0) && <span> ({t("zero_exercises")})</span> } 
                                                                { (numExercises == 1) && <span> ({ t("one_exercise") })</span> } 
                                                                { (numExercises > 1) && <span> ({ numExercises } { t("multiple_exercises") })</span> }   
                                                            </span>
                                                        </Nav.Link>
                                                    </Nav.Item>;
                                            })
                                        }
                                    </Nav>
                                </Col>
                                <Col lg={9}>
                                    <Tab.Content>
                                        {
                                            trainingSession.phases.map((p: TrainingSessionPhase) => {
                                                return <Tab.Pane key={ 'phase-pane-' + p.id } eventKey={ 'phase-' + p.id }>
                                                        <div className="pane-heading">
                                                            <h4>{ p.name }</h4>
                                                            { p.description &&
                                                                <div className="description">
                                                                    <div className="label">
                                                                        <span>{ t("description") }</span>
                                                                    </div>
                                                                    <div className="value">{ p.description }</div>
                                                                </div>
                                                            }
                                                            { p.goals &&
                                                                <div className="goals">
                                                                    <div className="label">
                                                                        <span>{ t("goals") }</span>
                                                                    </div>
                                                                    <div className="value">{ p.goals }</div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="phase-videos">
                                                            <EntityVideos entity_id={ p.id } label={ t("videos") } alert={ t("no_videos_in_phase") }
                                                                videos={ p.videos } updateEnebled={ false } onChange={ handleVideosChange } />
                                                        </div>
                                                        <div className="pane-exercises">
                                                            {
                                                                p.exercises.length == 0 &&
                                                                <Alert key="info" variant="info">
                                                                    { t("no_exercises_in_phase") }
                                                                </Alert>
                                                            }
                                                            { p.exercises.length > 0 &&
                                                                <div className="exercises">
                                                                    <div className="label">
                                                                        <span>{ t("exercises") }</span>
                                                                    </div>
                                                                    <div className="value">
                                                                        <Accordion defaultActiveKey={ 'exercise-' + p.exercises[0].id }>
                                                                            {
                                                                                p.exercises.map((e: TrainingSessionExercise) => {
                                                                                    return (
                                                                                        <Accordion.Item key={ 'accordion-item-' + e.id } eventKey={ 'exercise-' + e.id }>
                                                                                            <Accordion.Header>{ e.name }</Accordion.Header>
                                                                                            <Accordion.Body>
                                                                                                <div className="exercise-item">
                                                                                                    <div className="exercise-heading">
                                                                                                        { e.description.length > 0 &&
                                                                                                            <div className="description">
                                                                                                                <div className="label">
                                                                                                                    <span>{ t("description") }</span>
                                                                                                                </div>
                                                                                                                <div className="value">{ e.description }</div>
                                                                                                            </div>
                                                                                                        }
                                                                                                        { e.goals.length > 0 &&
                                                                                                            <div className="goals">
                                                                                                                <div className="label">
                                                                                                                    <span>{ t("goals") }</span>
                                                                                                                </div>
                                                                                                                <div className="value">{ e.goals }</div>
                                                                                                            </div>
                                                                                                        }
                                                                                                    </div>
                                                                                                    <EntityVideos entity_id={ e.id } label={ t("videos") } alert={ t("no_videos_in_excercise") }
                                                                                                        videos={ e.videos } updateEnebled={ false } onChange={ handleVideosChange } />
                                                                                                </div>
                                                                                            </Accordion.Body>
                                                                                        </Accordion.Item>);
                                                                                }) 
                                                                            }
                                                                        </Accordion>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </Tab.Pane>;
                                            })
                                        }
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    }
                </div>
            }
        </div>
    );
}
